export default __webpack_public_path__ + "static/media/img-36-velho.d8f5b24d.jpg";